import classes from '@styles/scss/site/cardRating.module.scss';
export default function RatingSiteDescription({ bottomLine }: { bottomLine: string }): JSX.Element {
    return (
        <>
            <div className={classes.siteDescription}>
                <strong>Bottom Line</strong> <p>{bottomLine}</p>
            </div>
        </>
    );
}
